import { localApiClient } from "./localApiClient";

const MACHINE_FINGERPRINT_KEY = "clearhealthLocalMachineFingerprint";

const storage = () => (typeof window === "undefined" ? null : window.localStorage);
const normalizeDeploymentMode = (value) => {
  const mode = String(value || "").trim().toUpperCase().replace(/[\s-]+/g, "_");
  if (mode === "HYBRID" || mode === "HYBRID_LOCAL_SERVER" || mode === "HYBRID_MODE") return "HYBRID";
  if (mode === "OFFLINE" || mode === "LOCAL" || mode === "LOCAL_EDITION" || mode === "OFFLINE_ONLY") return "OFFLINE";
  if (mode === "ONLINE" || mode === "CLOUD" || mode === "CLOUD_ONLY" || mode === "ONLINE_ONLY") return "ONLINE";
  return mode || "";
};

export const getLocalMachineFingerprint = () => {
  const existing = storage()?.getItem(MACHINE_FINGERPRINT_KEY);
  if (existing) return existing;
  const generated = `browser-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  storage()?.setItem(MACHINE_FINGERPRINT_KEY, generated);
  return generated;
};

export const normalizeActivationHospital = (status = {}) => ({
  ...status,
  id: status.id || status.hospitalId || "",
  hospitalId: status.hospitalId || status.id || "",
  hospitalName: status.hospitalName || status.name || "ClearHealth Local Hospital",
  name: status.name || status.hospitalName || "ClearHealth Local Hospital",
  deploymentMode: normalizeDeploymentMode(status.deploymentMode),
});

export const localActivationService = {
  async status() {
    return localApiClient.get("/activation/status");
  },

  async activateByCode({ activationCode }) {
    return localApiClient.post("/activation/activate-by-code", {
      activationCode,
      machineFingerprint: getLocalMachineFingerprint(),
    });
  },

  async generateOfflineChallenge(payload = {}) {
    return localApiClient.post("/activation/offline/challenge", payload);
  },

  async currentOfflineChallenge() {
    return localApiClient.get("/activation/offline/challenge/current");
  },

  async exportOfflineChallenge() {
    return localApiClient.post("/activation/offline/challenge/export", {});
  },

  async importOfflinePackage(packageFile) {
    return localApiClient.post("/activation/offline/import", { package: packageFile });
  },

  async offlineStatus() {
    return localApiClient.get("/activation/offline/status");
  },

  async confirmOfflineActivation() {
    return localApiClient.post("/activation/offline/confirm", {});
  },
};

export default localActivationService;
